import api from './axios';

// ================== TASK ASSIGNMENT ==================

// Assign a single task
export const assignTask = async (taskData) => {
  try {
    console.log('assignTask API call - Request data:', taskData);
    console.log('assignTask API call - Endpoint: /api/task-assignments');

    const response = await api.post('/api/task-assignments', taskData);

    console.log('assignTask API call - Response:', response.data);

    // Check if response has expected structure
    if (!response.data || typeof response.data !== 'object') {
      console.error('assignTask - Unexpected response structure:', response.data);
      return {
        isSuccess: false,
        message: 'Invalid response from server',
        data: null
      };
    }

    return response.data;
  } catch (error) {
    console.error('API Error in assignTask:', error);

    // Log detailed error information
    if (error.response) {
      console.error('Error response status:', error.response.status);
      console.error('Error response data:', error.response.data);
      console.error('Error response headers:', error.response.headers);
    } else if (error.request) {
      console.error('Error request:', error.request);
    } else {
      console.error('Error message:', error.message);
    }

    // Return a structured error response
    return {
      isSuccess: false,
      message: error.response?.data?.message || error.message || 'Failed to assign task',
      data: null,
      errors: error.response?.data?.errors || null
    };
  }
};

// Update task status
export const updateTaskStatus = async (id, status, notes = null) => {
  const response = await api.put(`/api/task-assignments/${id}/status`, { status, notes });
  return response.data;
};

// Log hours for a task
export const logTaskTime = async (id, hours, notes = null) => {
  const response = await api.post(`/api/task-assignments/${id}/log-time`, { hours, notes });
  return response.data;
};

// Get task by ID
export const getTaskById = async (id) => {
  const response = await api.get(`/api/task-assignments/${id}`);
  return response.data;
};

// Get tasks assigned to me
export const getMyTasks = async (status = null) => {
  const params = status !== null ? `?status=${status}` : '';
  const response = await api.get(`/api/task-assignments/my-tasks${params}`);
  return response.data;
};

// Get my task statistics
export const getMyTaskStats = async () => {
  const response = await api.get('/api/task-assignments/my-stats');
  return response.data;
};

export const updateTask = async (taskId, taskData) => {
  try {
    console.log('updateTask API call - Request data:', taskData);
    console.log('updateTask API call - Endpoint: /api/task-assignments/' + taskId);

    const response = await api.put(`/api/task-assignments/${taskId}`, taskData);

    console.log('updateTask API call - Response:', response.data);

    return response.data;
  } catch (error) {
    console.error('API Error in updateTask:', error);

    if (error.response) {
      console.error('Error response status:', error.response.status);
      console.error('Error response data:', error.response.data);
    }

    return {
      isSuccess: false,
      message: error.response?.data?.message || error.message || 'Failed to update task',
      data: null,
      errors: error.response?.data?.errors || null
    };
  }
};

// Get task assignment history
export const getTaskHistory = async (taskId) => {
  const response = await api.get(`/api/task-assignments/${taskId}/history`);
  return response.data;
};

// ================== USER MANAGEMENT ==================
export const getAllUsers = async () => {
  try {
    const response = await api.get('/api/auth/GetAllUsers');
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      isSuccess: false,
      message: 'Failed to fetch users',
      data: []
    };
  }
};

/**
 * Lightweight user lookup (id + name only).
 */
export const getUserLookup = async () => {
  try {
    const response = await api.get('/api/auth/lookup');
    return response.data;
  } catch (error) {
    console.error('Error fetching user lookup:', error);
    return {
      isSuccess: false,
      message: 'Failed to fetch user lookup',
      data: []
    };
  }
};

// ================== ENUMS & HELPERS ==================
export const TaskAssignmentStatus = {
  Assigned: 0,
  InProgress: 1,
  Paused: 2,
  Completed: 3,
  Cancelled: 4
};

export const TaskPriority = {
  Low: 0,
  Normal: 1,
  High: 2,
  Urgent: 3
};

export const getStatusName = (status) => {
  const names = ['Assigned', 'In Progress', 'Paused', 'Completed', 'Cancelled'];
  return names[status] || 'Unknown';
};

export const getPriorityName = (priority) => {
  const names = ['Low', 'Normal', 'High', 'Urgent'];
  return names[priority] || 'Unknown';
};

export const getStatusBadgeColor = (status) => {
  const colors = {
    0: 'bg-blue-100 text-blue-800',
    1: 'bg-yellow-100 text-yellow-800',
    2: 'bg-orange-100 text-orange-800',
    3: 'bg-green-100 text-green-800',
    4: 'bg-red-100 text-red-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};

export const getPriorityBadgeColor = (priority) => {
  const colors = {
    0: 'bg-gray-100 text-gray-600',
    1: 'bg-blue-100 text-blue-800',
    2: 'bg-orange-100 text-orange-800',
    3: 'bg-red-100 text-red-800'
  };
  return colors[priority] || 'bg-gray-100 text-gray-800';
};